import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, IconButton, InputLabel, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { FastField, FieldArray } from 'formik';
import _e from 'common/localeUtil';
import FieldWrapper from './FieldWrapper';

const useListItemFormStyles = makeStyles((theme) => ({
	descriptionField: {
		marginTop: theme.spacing(1),
	},
	formRowWrapper: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
	},
	formRowItemWrapper: {
		width: '50%',
		display: 'flex',
	},
	formRow: {
		width: '100%',
		flexDirection: 'column',
		padding: theme.spacing(1.5),
		border: '1px #ccc solid',
		borderRadius: 4,
		backgroundColor: '#fefefe',
		position: 'relative',
		'&:hover': {
			backgroundColor: '#f1f1f1',
		},
		'&:hover .deletePanel': {
			display: 'initial',
		},
	},
	formInput: {
		paddingTop: theme.spacing(1),
		paddingBottom: theme.spacing(1),
	},
	arrayActionItem: {
		width: '100%',
		alignItems: 'center',
		justifyContent: 'center',
	},
	deletePanel: {
		position: 'absolute',
		top: theme.spacing(1),
		right: theme.spacing(1),
		backgroundColor: '#555',
		borderRadius: theme.spacing(0.5),
		color: 'white',
		display: 'none',
	},
}));

const ListItemSubForm = ({ name, title, values = [], maxRows = 5, minRows = 1, example = {} }) => {
	const classes = useListItemFormStyles();
	// console.log('ListItemSubForm', { name, title, values, maxRows, minRows, example });
	const deleteAble = values.length > minRows;
	return (
		<Box>
			<Typography variant="body1">{title}</Typography>
			<FieldArray name={name}>
				{(arrayHelpers) => (
					<Box className={classes.formRowWrapper}>
						<Box p={2} className={classes.formRowItemWrapper}>
							<Box key="row-example" className={classes.formRow} mt={2}>
								<Typography variant="body1">{`#${_e('example')}`}</Typography>
								<InputLabel className="mt-2">{_e('title')}</InputLabel>
								<Typography variant="body1" className={classes.formInput}>
									{example.title}
								</Typography>
								<InputLabel className="mt-4">{_e('description')}</InputLabel>
								<Typography variant="body1" className={classes.formInput}>
									{example.description}
								</Typography>
							</Box>
						</Box>
						{values.map((item, index) => (
							<Box p={2} className={classes.formRowItemWrapper} key={index}>
								{}
								<Box key={`row-${index}`} className={classes.formRow} mt={2}>
									<Typography variant="body1">#{index + 1}</Typography>
									<InputLabel className="mt-2">{_e('title')}</InputLabel>
									<FastField
										name={`${name}.${index}.title`}
										component={FieldWrapper}
										control="input"
										type="text"
										showErrorAsPopover
										className="mt-1"
										size="small"
									/>

									<InputLabel className="mt-4">Description</InputLabel>
									<FastField
										name={`${name}.${index}.description`}
										component={FieldWrapper}
										control="input"
										type="text"
										fullWidth
										rows={3}
										rowsMax={5}
										multiline
										className="mt-1"
										showErrorAsPopover
									/>
									<Box className={`${classes.deletePanel} deletePanel`}>
										{deleteAble && (
											<IconButton
												id={
													name.includes('accolades')
														? `delete-accolade-${index}`
														: `delete-service-${index}`
												}
												onClick={() => arrayHelpers.remove(index)}
												size="small"
												color="inherit"
											>
												<Close color="white" />
											</IconButton>
										)}
									</Box>
								</Box>
							</Box>
						))}
						<Box
							display="flex"
							justifyContent="center"
							mt={2}
							className={classes.arrayActionItem}
						>
							<Button
								disabled={values.length >= maxRows}
								variant="contained"
								color="primary"
								onClick={() => arrayHelpers.push({ title: '', description: '' })}
							>
								Add item
							</Button>
						</Box>
					</Box>
				)}
			</FieldArray>
		</Box>
	);
};

ListItemSubForm.propTypes = {
	name: PropTypes.string,
	example: PropTypes.object,
	title: PropTypes.string,
	maxRows: PropTypes.number,
	minRows: PropTypes.number,
	values: PropTypes.array,
};

export default ListItemSubForm;
